(function ($, njm) {
    'use strict';

    njm.views.noCookie = Backbone.View.extend({

        events: {
            'click .dismiss': 'dismiss'
        },

        /**
         * Initialize
         */
        initialize: function () {
            $(this.el).hide();
            if (!this.cookieEnabled()) {
                $(this.el).show();
            }
        },

        /**
         *
         * @returns {boolean}
         */
        cookieEnabled: function () {
            document.cookie = 'test=cookieEnabled';
            return document.cookie.length > 0 && document.cookie.indexOf('test=cookieEnabled') >= 0;
        },

        /**
         * Dismiss
         */
        dismiss: function () {
            $(this.el).slideUp();
        }

    });
})(jQuery, njm);
